import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { selectDefaultCreationEnvironment } from '../components/pages/environments/environmentsReducer';
import { isSnowflakeAllowedRoute } from '../constants/snowflakeConstants';
import { appRoutes } from '../constants/appRoutes';
import useSweepNavigate from '../navigation-utils/useSweepNavigate';

export const useSnowflakeRouteGuard = () => {
  const { pathname } = useLocation();
  const { navigate } = useSweepNavigate();
  const defaultCreationEnv = useSelector(selectDefaultCreationEnvironment);
  const isSnowflakeEnv = defaultCreationEnv?.orgType === 'snowflake';

  useEffect(() => {
    if (isSnowflakeEnv && !isSnowflakeAllowedRoute(pathname)) {
      navigate(appRoutes.getStarted.route, { replace: true });
    }
  }, [isSnowflakeEnv, pathname, navigate]);
};
